<template>
  <div class="supervisor-reservation" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="预约整包" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="default-top-bg">
      <div class="title">基本信息</div>
    </div>
    <div class="content-form">
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">联系人</div>
        <input class="form-input" type="text" v-model="appointment.name" placeholder="请输入联系人"/>
        <div class="form-input-box-sex">
          <div class="sex-radio" @click="sexClick(1)">
            <img v-if="sexStatus == 1" src="../../assets/icon/icon-check-box-selected.png">
            <img v-if="sexStatus != 1" src="../../assets/icon/icon-check-box-unselect.png">男
          </div>
          <div class="sex-radio" @click="sexClick(0)">
            <img v-if="sexStatus == 0" src="../../assets/icon/icon-check-box-selected.png">
            <img v-if="sexStatus != 0" src="../../assets/icon/icon-check-box-unselect.png">女
          </div>
        </div>
      </div>
      <div v-if="deposit > 0" class="appointment-form-item border-bottom-style">
        <div class="form-title">订金</div>
        <div class="appointment-deposit">{{deposit}}元</div>
      </div>
      <div class="appointment-form-item border-bottom-style" @click="selectHouseType()">
        <div class="form-title">户型</div>
        <input class="form-input" readonly type="text" v-model="houseTypeShow" placeholder="选择户型"/>
        <img class="icon-form-select" src="../../assets/icon/icon-drop-down.png">
      </div>
      <div class="appointment-form-item border-bottom-style" @click="selectArea()">
        <div class="form-title">区域</div>
        <input class="form-input" readonly type="text" v-model="areaName" placeholder="选择区域"/>
        <img class="icon-form-select" src="../../assets/icon/icon-drop-down.png">
      </div>
      <div class="appointment-form-item border-bottom-style" @click="selectHouseState()">
        <div class="form-title">房屋类型</div>
        <input class="form-input" type="text" readonly v-model="houseStateShow" placeholder="选择房屋类型"/>
        <img class="icon-form-select" src="../../assets/icon/icon-drop-down.png">
      </div>
      <div class="appointment-form-item border-bottom-style" @click="selectDecorateType()">
        <div class="form-title">装修类型</div>
        <input class="form-input" type="text" readonly v-model="decorateTypeShow" placeholder="选择装修类型"/>
        <img class="icon-form-select" src="../../assets/icon/icon-drop-down.png">
      </div>
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">面积</div>
        <input class="form-input" type="number" v-model="appointment.houseArea" placeholder="请输入平方数"/>
        <div class="form-unit">平米</div>
      </div>
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">小区</div>
        <input class="form-input" type="text" v-model="appointment.village" placeholder="请输入小区名称"/>
      </div>
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">手机号</div>
        <input class="form-input" type="number" v-model="appointment.phone" placeholder="请输入手机号"/>
      </div>
      <div class="appointment-submit-btn" :class="{disable:isDisabled}" @click="checkAppointment()">提交</div>
    </div>
    <!--已预约是否再次预约的提示框-->
    <div v-if="alertCheck" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelAlert()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">已预约，您要再次预约吗？</div>
      <div class="agree-btn" @click="confirmAlert()">再次预约</div>
    </div>
    <div v-if="alertCheck" class="pay-box"></div>
    <div v-if="alertSuccess" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="goback()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">预约成功！</div>
      <div class="agree-btn" @click="openAppointmentDetail()">查看预约</div>
    </div>
    <div v-if="alertSuccess" class="pay-box"></div>
    <div v-if="showSelectArea" class="toast appointment-select-part">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="confirmSelectArea">
      <div class="select-title">请选择区域</div>
      <div class="appointment-area-select-list">
        <div v-for="area in areaList" @click="selectAppointmentArea(area.value,area.text)"  class="select-item" :class="{selected: area.value == areaId}">{{area.text}}</div>
      </div>
    </div>
    <div v-if="showSelectArea" class="pay-box"></div>

    <div v-if="showSelectHouseState" class="toast appointment-select-part">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="confirmSelectHouseState">
      <div class="select-title">请选择房屋类型</div>
      <div class="appointment-area-select-list">
        <div v-for="houseStateItem in houseStateList" @click="selectAppointmentHouseState(houseStateItem.value,houseStateItem.text)"  class="select-item" :class="{selected: houseStateItem.value === houseState}">{{houseStateItem.text}}</div>
      </div>
    </div>
    <div v-if="showSelectHouseState" class="pay-box"></div>

    <div v-if="showSelectDecorateType" class="toast appointment-select-part">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="confirmSelectDecorateType">
      <div class="select-title">请选择装修类型</div>
      <div class="appointment-area-select-list">
        <div v-for="decorateTypeItem in decorateTypeList" @click="selectAppointmentDecorateType(decorateTypeItem.value,decorateTypeItem.text)"  class="select-item" :class="{selected: decorateTypeItem.value === decorateType}">{{decorateTypeItem.text}}</div>
      </div>
    </div>
    <div v-if="showSelectDecorateType" class="pay-box"></div>

    <div v-if="showSelectHouseType" class="toast appointment-select-part">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="confirmSelectHouseType">
      <div class="select-title">请选择户型</div>
      <div class="appointment-select-list">
        <div class="appointment-select-group">
          <div v-for="roomType in roomTypeList" class="select-item" :class="{selected: roomType.value == room}" @click="selectRoom(roomType.value,roomType.showText)">{{roomType.text}}</div>
        </div>
        <div class="appointment-select-group">
          <div v-for="parlourType in parlourTypeList" class="select-item" :class="{selected: parlourType.value == parlour}" @click="selectParlour(parlourType.value,parlourType.showText)">{{parlourType.text}}</div>
        </div>
        <div class="appointment-select-group">
          <div v-for="toiletType in toiletTypeList" class="select-item" :class="{selected: toiletType.value == toilet}" @click="selectToilet(toiletType.value,toiletType.showText)">{{toiletType.text}}</div>
        </div>
        <div class="appointment-select-group">
          <div v-for="kitchenType in kitchenTypeList" class="select-item" :class="{selected: kitchenType.value == kitchen}" @click="selectKitchen(kitchenType.value,kitchenType.showText)">{{kitchenType.text}}</div>
        </div>
      </div>
    </div>
    <div v-if="showSelectHouseType" class="pay-box"></div>
  </div>
</template>

<style lang="scss">
  @import '../../assets/style/common.scss';
  @import '../../assets/style/supervisor-appointment.scss';
  .disable{
    background-color: #f5f5f5 !important;
    color: #cecbca !important;
    pointer-events: none;
  }
</style>

<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import AppointmentService from '../../service/customer/AppointmentService'
  import AreaService from '../../service/core/AreaService'
  import shareService from '../../service/share/ShareService'
  import onestopCompanyService from '../../service/company/CompanyService'
  import payUtil from '../../utils/Pay'

  export default {
    name: 'OnestopReservation',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        onestopCaseId:'',
        companyId:'',
        sexStatus:1,
        areaId:'',
        areaName:'',
        room:'',
        roomShowText:'',
        parlour:'',
        parlourShowText:'',
        toilet:'',
        toiletShowText:'',
        kitchen:'',
        kitchenShowText:'',
        roomTypeList:[{value:1,text:'一室',showText:'一室'},{value:2,text:'两室',showText:'两室'},{value:3,text:'三室',showText:'三室'},{value:4,text:'四室',showText:'四室'},{value:5,text:'五室',showText:'五室'}],
        parlourTypeList:[{value:1,text:'一厅',showText:'一厅'},{value:2,text:'两厅',showText:'两厅'},{value:3,text:'三厅',showText:'三厅'},{value:4,text:'四厅',showText:'四厅'},{value:5,text:'五厅',showText:'五厅'}],
        toiletTypeList:[{value:1,text:'一卫',showText:'一卫'},{value:2,text:'两卫',showText:'两卫'},{value:3,text:'三卫',showText:'三卫'},{value:4,text:'四卫',showText:'四卫'},{value:5,text:'五卫',showText:'五卫'}],
        kitchenTypeList:[{value:1,text:'一厨',showText:'一厨'},{value:2,text:'两厨',showText:'两厨'},{value:3,text:'三厨',showText:'三厨'},{value:4,text:'四厨',showText:'四厨'},{value:5,text:'五厨',showText:'五厨'}],
        houseTypeShow:'',
        areaList:[{value:0,text:'请选择'}],
        appointment:{phone:''},
        code:'',
        sendStatus: false,
        sendTime: 60,
        sendButtonText: '获取验证码',
        waitSend:false,
        alertCheck:false,
        alertSuccess:false,
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        isWechatBrowser:this.$verfyBrowserType(),
        showSelectArea:false,
        showSelectHouseType:false,
        houseType:{},
        showOtherHouseType:false,
        caseTitle:'',
        casePrice:'',
        houseStateList:[{value:0,text:'旧房'},{value:1,text:'新房'}],
        decorateTypeList:[{value:1,text:'整体装修'},{value:2,text:'局部装修'}],
        houseStateShow:'',
        decorateTypeShow:'',
        showSelectHouseState:false,
        showSelectDecorateType:false,
        houseState:'',
        decorateType:'',
        companyInfo:{},
        deposit:0,
        prePayInfo:{},
        tradeAppointmentId:'',
        appointmentId:'',
        isDisabled: false,
      }
    },
    created(){
      this.casePrice = this.$route.query.casePrice;
      this.caseTitle = this.$route.query.caseTitle;
      this.companyId = this.$route.query.companyId;
      this.deposit = this.$route.query.deposit;
      this.onestopCaseId =this.$route.query.onestopCaseId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getAreaList('2');
      this.initWechatShare();
      this.getCompanyDetail();
    },

    methods: {
      sexClick(num){
        if(num == 1){
          this.sexStatus=1;
        }else {
          this.sexStatus=0;
        }
      },
      async getCompanyDetail(){
        var result = await onestopCompanyService.getCompanyInfo(this.companyId);
        if(result.code == 0){
          this.companyInfo = result.data.company;
        }else {
          Toast('获取方案所属公司信息失败，请稍后重试!');
        }
      },

      async getAreaList(cityId){
        this.areaList = [];
        var result=await AreaService.getAreaList(cityId);
        if(result.code == 0){
          var areas = result.data;
          var that = this;
          $(areas).each(function () {
            this.value=this.id;
            this.text=this.name;
            that.areaList.push(this);
          });
        }else {
          Toast('获取城市区域列表信息失败');
        }
      },
      /**
       * 验证手机号码（移动电话）
       */
      mobilePhone(){
        var phone = this.appointment.phone;
        if (phone == '') {
          Toast('请输入手机号码！');
          return false;
        }
        var re= /^1[3578]\d{9}$/;
        if(re.test(phone)){
          return true;
        } else {
          Toast('手机号码格式不正确!');
          return false;
        }
      },
      computeSendTime () {
        if (this.sendStatus) {
          if (this.sendTime == 0) {
            this.waitSend = false;
            this.sendStatus = false;
            this.sendButtonText = '重新获取'
          } else {
            this.waitSend = true;
            this.sendTime = this.sendTime - 1;
            this.sendButtonText = this.sendTime + '秒';
            setTimeout(() => {
              this.computeSendTime()
            }, 1000)
          }
        }
      },
      async checkAppointment(){
        if(!this.companyInfo.quota > 0){
          Toast('该公司预约已满,请选择其他公司!')
          return;
        }
        if (this.appointment.name == null || this.appointment.name == '') {
          Toast('请填写联系人姓名！');
          return;
        }
        if (this.room == '' || this.parlour == '') {
          Toast('请完善您的户型信息!');
          return;
        }
        if (this.areaId == '') {
          Toast('请选择区域！');
          return;
        } else {
          this.appointment.cityId = 2;
          this.appointment.areaId = this.areaId;
        }
        if(this.houseState === ''){
          Toast('请选择房屋类型！');
          return;
        }
        if(this.decorateType === ''){
          Toast('请选择装修类型！');
          return;
        }
        if (this.appointment.houseArea == null || this.appointment.houseArea == '') {
          Toast('请填写住房面积！');
          return;
        }
        if(this.appointment.village == null || this.appointment.village == ''){
          Toast('请填写小区名称！');
          return;
        }
        if (!this.mobilePhone()) {
          return;
        }

        this.appointment.type = 5;
        this.appointment.companyId = this.companyId;
        this.appointment.sex = this.sexStatus;
        this.appointment.room = this.room;
        this.appointment.parlour = this.parlour;
        this.appointment.toilet = this.toilet;
        this.appointment.kitchen = this.kitchen;
        this.appointment.houseType = this.houseState;
        this.appointment.decorateType = this.decorateType;
        this.appointment.customerId = session.getAccountToken().id == undefined ? '' : session.getAccountToken().id;
        this.isDisabled = true;
        console.log(this.appointment,'appointment>>>')
        var res = await AppointmentService.checkAppointment(this.appointment);
        if (res.code == '0') {
          if (res.data == '1') {
            if(this.deposit && this.deposit>0){
              this.isDisabled = false;
              let prepayResult = await AppointmentService.prePayAppointment(this.appointment,this.deposit);
              console.info('prepayResult',prepayResult)
              if(prepayResult.code == '0'){
                this.tradeAppointmentId = prepayResult.data.tradeAppointmentId;
                this.prePayInfo = payUtil.pay(prepayResult.data.prepayId,prepayResult.data.nonceStr);
                let requestPay = this.requestPay;
                if (typeof WeixinJSBridge == "undefined"){
                  if( document.addEventListener ){
                    document.addEventListener('WeixinJSBridgeReady', requestPay.bind(this), false);
                  }else if (document.attachEvent){
                    document.attachEvent('WeixinJSBridgeReady', requestPay.bind(this));
                    document.attachEvent('onWeixinJSBridgeReady', requestPay.bind(this));
                  }
                }else{
                  this.requestPay();
                }
              } else {
                Toast(prepayResult.msg);
              }

            }else {
              this.appointment.isDeposited = '0';
              this.createAppointment();
            }
          } else {
            this.alertCheck = true;
          }
        } else {
          this.isDisabled = false;
          Toast('预约失败，请稍后再试！');
        }
      },
      selectArea(){
        this.showSelectArea = true;
      },
      closeSelectArea(){
        this.showSelectArea = false;
      },
      selectAppointmentArea(areaId,areaName){
        this.areaId = areaId;
        this.areaName = areaName;
      },
      confirmSelectArea(){
        this.showSelectArea = false;
      },
      selectHouseType(){
        this.showSelectHouseType = true;
      },
      confirmSelectHouseType(){
        this.houseTypeShow = this.roomShowText + this.parlourShowText + this.toiletShowText + this.kitchenShowText;
        this.showSelectHouseType = false;
      },
      selectRoom(room,showText){
        if(this.room != room){
          this.roomShowText = showText;
          this.room = room;
        } else {
          this.roomShowText = '';
          this.room = '';
        }
      },
      selectParlour(parlour,showText){
        if(this.parlour != parlour){
          this.parlourShowText = showText;
          this.parlour = parlour;
        } else {
          this.parlourShowText = '';
          this.parlour = '';
        }
      },
      selectToilet(toilet,showText){
        if(this.toilet != toilet){
          this.toiletShowText = showText;
          this.toilet = toilet;
        } else {
          this.toiletShowText = '';
          this.toilet = '';
        }
      },
      selectKitchen(kitchen,showText){
        if(this.kitchen != kitchen){
          this.kitchenShowText = showText;
          this.kitchen = kitchen;
        } else {
          this.kitchenShowText = '';
          this.kitchen = '';
        }
      },
      cancelAlert(){
        this.isDisabled = false;
        this.alertCheck = false;
      },
      async confirmAlert(){
        if(this.deposit && this.deposit>0){
          this.isDisabled = false;
          let prepayResult = await AppointmentService.prePayAppointment(this.appointment,this.deposit);
          console.info('confirmAlertprepayResult',prepayResult)
          if(prepayResult.code == '0'){
            this.tradeAppointmentId = prepayResult.data.tradeAppointmentId;
            this.prePayInfo = payUtil.pay(prepayResult.data.prepayId,prepayResult.data.nonceStr);
            let requestPay = this.requestPay;
            if (typeof WeixinJSBridge == "undefined"){
              if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', requestPay, false);
              }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', requestPay);
                document.attachEvent('onWeixinJSBridgeReady', requestPay);
              }
            }else{
              this.requestPay();
            }
          } else {
            Toast(prepayResult.msg);
          }
        }else {
          this.appointment.isDeposited = '0';
          this.createAppointment();
        }
      },
      selectHouseState(){
        this.showSelectHouseState = true;
      },
      selectDecorateType(){
        this.showSelectDecorateType = true;
      },
      selectAppointmentHouseState(houseState,houseStateShow){
        this.houseState = houseState;
        this.houseStateShow = houseStateShow;
      },
      selectAppointmentDecorateType(decorateType,decorateTypeShow){
        this.decorateType = decorateType
        this.decorateTypeShow = decorateTypeShow;
      },
      confirmSelectHouseState(){
        this.showSelectHouseState = false;
      },
      confirmSelectDecorateType(){
        this.showSelectDecorateType = false;
      },
      goback () {
        this.$router.go(-1);
      },
      openAppointmentDetail(){
        this.$router.push({name:'MineAppointment',query:{}});
      },
      async createAppointment(){
        var result = await AppointmentService.createAppointment(this.appointment);
        if(result.code == '0'){
          this.alertSuccess = true;
          this.appointment = result.data;
          this.appointmentId = this.appointment.id;
        }else {
          this.isDisabled = false;
          Toast('预约失败');
        }
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.appointment.tradeAppointmentId = that.tradeAppointmentId;
                that.appointment.isDeposited = 1;
                that.createAppointment();
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
      async initWechatShare(){
        let title = this.caseTitle+ this.casePrice + '元/平预约入口';// 分享标题
        let desc = ""; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
    }
  }
</script>

